<template>
  <v-container fluid>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <span class="title">Аккаунты расширения Blacklist без привязки к Telegram.</span>
          <v-spacer></v-spacer>
          <span class="title">
           Подключено: {{ items.length }} &nbsp;&nbsp;&nbsp;&nbsp;
           Оплачено: {{ Number(accCount)+Number(items.length) }} ({{ accCount }})
          </span> 
          <v-spacer></v-spacer>
          <v-btn class="brown lighten-1" fab small dark @click.native="reloadData()">
            <v-icon>refresh</v-icon>
          </v-btn>
          <v-btn class="deep-orange darken-1" fab small dark @click.native="add"  title="Добавить сотрудника в команду">
            <v-icon>add</v-icon>
          </v-btn>


        </v-card-title>
        <v-data-table class="elevation-1" v-bind:headers="headers" v-bind:items="items" v-bind:search="search" hide-actions>
            <template slot="headers" slot-scope="props">
                <tr>
                  <th>Nick name</th>
                  <th>Последний доступ:</th>
                  <th>Оплачено до:</th>
                  <th>Код авторизации:</th>
                </tr>
          </template>
          <template class="body-2" slot="items" slot-scope="props">

          <td width="280"><v-text-field name="nick_name" @input="changeInput(props.item, 'nick_name')" v-model="props.item.nick_name" hide-details ></v-text-field></td>

            <td class="text-xs-center body-2"> {{ props.item.last_access }} </td>
            <td class="text-xs-center body-2"> {{ props.item.paid_until }} </td>
            <td class="text-xs-center body-2"><b> {{ props.item.auth }} </b></td>
            <td class="text-xs-right">

              <v-btn class="" fab small flat @click.native="remove(props.item)" title="Удалить сотрудника из команды">
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
      </v-card>
    </v-flex>
    <confirm-dialog :dialog="dialog" :dialogTitle="dialogTitle" :dialogText="dialogText" @onConfirm="onConfirm" @onCancel="onCancel" ></confirm-dialog>
      <v-snackbar v-if="snackbar" :right="true" :timeout="timeout" :color="mode" v-model="snackbar" >
      {{ notice }}
      <v-btn dark flat @click.native="closeSnackbar">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
/* globals Store */
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { mapState } from "vuex";
import { debounce } from "lodash";

export default {
  components: {
    ConfirmDialog
  },
  data () {
    return {
      dialog: false,
      dialogTitle: "Customer Delete Dialog",
      dialogText: "Вы действительно хотите удалить сотрудника?",
      right: true,
      search: '',
      headers: [
        { text: 'Id', left: true, value: 'id' },
        { text: 'Nickname', left: true, value: 'nick_name' },
        { text: 'Статус автороизации:', value: 'check_count' },
        { text: 'Последний доступ:', value: 'balance' },
        { text: 'Оплачено до:', value: 'paid_until' },
        { text: 'Код авторизации:', value: 'auth' },
      ],
      searchVm: {
        contains: {
          firstName: '',
          lastName: ''
        },
        between: {
          rewards: { former: 0, latter: 0 }
        }
      },
      customerId: "",
      query: "",
      snackbar: false,
      timeout: 2000,
      color: "",
      quickSearchFilter: "",
    }
  },
  methods: {
    add () {
        Store.dispatch('workers/addExtWorker', this.nickname);
    },
    changeInput (item, field) {
      this.$nextTick(() => {
        let id = item.id;
        let value = item[field];
        const query = this.query;
        Store.dispatch("workers/changeInput", { id, field, value, query });
      })
    },
    remove (item) {
      this.orderId = item.id;
      this.dialog = true;
    },
    onConfirm () {
      Store.dispatch("workers/deleteExtWorker", this.orderId);
      this.dialog = false;
    },
    onCancel () {
      this.orderId = "";
      this.dialog = false;
    },
    reloadData () {
      this.query = "";
      Store.dispatch("workers/getExtWorkers");
    },
    closeSnackbar () {
      Store.commit("workers/setNotice", { notice: "" });
    },
  },
  computed: {
    ...mapState("workers", {
      items: "extWorkers",
      accCount: "extWorkersAccCount",
      loading: "loading",
      mode: "mode",
      notice: "notice"
    }),
  },
  watch: {
    notice() {
      Store.dispatch("workers/getExtWorkers");
      Store.dispatch("inform/getInfo", {});
      if (this.notice !== ''){
        this.snackbar = true;
      }
    },
    snackbar() {
      if (!this.snackbar){
        Store.commit("workers/setNotice", { notice: "" });
      }
    },
  },
  created () {
    this.closeSnackbar();
    Store.dispatch("workers/getExtWorkers");
    Store.dispatch("inform/getInfo", {});
  },
  mounted () {
    this.$Progress.finish();
  }
}
</script>



// WEBPACK FOOTER //
// Extention.vue?7e8b7218